import React, { memo } from 'react';

export const AILoadingLottiePoster = memo(() => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_9)">
        <path
          d="M9.02599 1.7555C9.4051 1.7555 9.73557 2.01352 9.82751 2.3813L10.0372 3.21994C10.8512 6.47605 13.3936 9.01844 16.6496 9.83248L17.4883 10.0422C17.8562 10.1341 18.1141 10.4646 18.1141 10.8437C18.1141 11.2228 17.856 11.5533 17.4883 11.6452L16.6498 11.8549C13.3936 12.6688 10.8512 15.2112 10.0371 18.4674L9.82751 19.306C9.73557 19.6738 9.4051 19.9317 9.02599 19.9317C8.64688 19.9317 8.31641 19.6738 8.22447 19.306L8.01483 18.4674C7.2008 15.2112 4.65834 12.6688 1.40217 11.8549L0.563698 11.6452C0.195894 11.5533 -0.0621262 11.2228 -0.0621262 10.8437C-0.0621262 10.4646 0.195877 10.1341 0.563681 10.0422L1.40232 9.83248C4.65842 9.01844 7.20078 6.47605 8.01481 3.21994L8.22447 2.3813C8.31641 2.01352 8.64688 1.7555 9.02599 1.7555Z"
          fill="#116DFF"
        />
        <path
          d="M15.7477 -0.0621262C15.9017 -0.0621262 16.036 0.0427019 16.0733 0.192126L16.1585 0.532846C16.4892 1.85573 17.5221 2.88865 18.845 3.21938L19.1857 3.30457C19.3352 3.34193 19.44 3.47619 19.44 3.63022C19.44 3.78424 19.3351 3.9185 19.1857 3.95585L18.845 4.04104C17.5221 4.37173 16.4892 5.40464 16.1585 6.72756L16.0733 7.06826C16.036 7.2177 15.9017 7.32249 15.7477 7.32249C15.5936 7.32249 15.4594 7.2177 15.422 7.06826L15.3369 6.72756C15.0061 5.40464 13.9732 4.37173 12.6503 4.04104L12.3096 3.95585C12.1602 3.9185 12.0554 3.78424 12.0554 3.63022C12.0554 3.47619 12.1602 3.34193 12.3096 3.30457L12.6503 3.21938C13.9732 2.88865 15.0061 1.85573 15.3368 0.532846L15.422 0.192126C15.4594 0.0427019 15.5936 -0.0621262 15.7477 -0.0621262Z"
          fill="#116DFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_9">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
});
